import * as yup from 'yup';

const createEstateSchema = yup.object({
  name: yup.string().max(50, 'Must be under 50 characters').required('Estate is required'),
  location: yup.object({
    // location_pin: yup.string().required('Location pin is required.'),
    location_pin: yup.string(),
    village: yup.string().required('Village is required.'),
  }),
  altitude: yup
    .number()
    .transform((value, originalValue) => (originalValue === '' ? null : value))
    .nullable()
    .optional(),
  estate_code: yup
    .string()
    .min(1, 'Estate code must have at least 1 character.')
    .max(3, 'Estate code must be at most 3 characters.')
    .required('Estate code is required.'),
  size_in_acres: yup
    .number()
    .typeError('Enter a valid number')
    .positive()
    .test('max-2-decimals', 'Use at most two decimals', value => value === undefined || Number.isInteger(value * 100))
    .required('Estate area is required'),
  growers: yup
    .array()
    .of(
      yup.object({
        name: yup.string().required('Grower name is required.'),
        phone_number: yup
          .string()
          .matches(/^(\+?\d{1,3})?\d{10}$/, 'Enter a valid phone number. Country code is optional.')
          .required('Grower number is required.'),
      })
    )
    .min(1, 'Grower details are required.')
    .required('Grower details is required.'),
  managers: yup.array().of(
    yup.object({
      // name: yup.string().required('Manager name is required.'),
      name: yup.string().optional(),
      phone_number: yup
        .string()
        .transform((value, originalValue) => (originalValue === '' ? null : value))
        .nullable()
        .matches(/^(\+?\d{1,3})?\d{10}$/, 'Enter a valid phone number. Country code is optional.')
        .optional(),
      // phone_number: yup
      //   .string()
      //   .matches(/^(\+?\d{1,3})?\d{10}$/, 'Enter a valid phone number. Country code is optional.')
      //   .optional(),
      // .required('Manager number is required.'),
    })
  ),
  varietal_details: yup
    .array()
    .of(
      yup.object({
        varietal: yup.string().required('Varietal name is required.'),
        area_in_acres: yup
          .number()
          .transform(value => (value === '' ? undefined : value))
          .typeError('Enter a valid number')
          .positive()
          .test(
            'max-2-decimals',
            'Use at most two decimals',
            value => value === undefined || Number.isInteger(value * 100)
          )
          .required('Area is required.'),
      })
    )
    .required('Varietal details is required.'),
});

export default createEstateSchema;
